import { E_RESET_ERROR, E_SET_ERROR } from '../../constants'

export interface ErrorState {
  desc: string
  isError: boolean
}

const initialState: ErrorState = {
  isError: false,
  desc: ''
}

export default (state = initialState, { type, payload }: any): ErrorState => {
  switch (type) {
    case E_SET_ERROR:
      return { ...state, isError: true, desc: payload }

    case E_RESET_ERROR:
      return initialState
    default:
      return state
  }
}
